import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { WorkflowHookDetails } from "./components/WorkflowHookDetails";

export function WorkflowHookPage() {
  return (
    <LqsPage title="Hook Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <WorkflowHookDetails />
      </Container>
    </LqsPage>
  );
}
